import React, { useEffect, useRef } from 'react';
import { Terminal as XTerm } from '@xterm/xterm';
import { FitAddon } from '@xterm/addon-fit';
import { WebLinksAddon } from '@xterm/addon-web-links';
import '@xterm/xterm/css/xterm.css';

const WS_URL = 'wss://daveya.in/terminal';

export default function Terminal() {
  const termRef = useRef(null);
  const xtermRef = useRef(null);

  useEffect(() => {
    if (!termRef.current || xtermRef.current) return;

    const term = new XTerm({
      cursorBlink: true,
      fontSize: 14,
      fontFamily: "'SF Mono', 'Fira Code', 'Cascadia Code', 'Menlo', monospace",
      theme: {
        background: '#1a1b26',
        foreground: '#c0caf5',
        cursor: '#c0caf5',
        selectionBackground: '#33467c',
        black: '#15161e',
        red: '#f7768e',
        green: '#9ece6a',
        yellow: '#e0af68',
        blue: '#7aa2f7',
        magenta: '#bb9af7',
        cyan: '#7dcfff',
        white: '#a9b1d6',
        brightBlack: '#414868',
        brightRed: '#f7768e',
        brightGreen: '#9ece6a',
        brightYellow: '#e0af68',
        brightBlue: '#7aa2f7',
        brightMagenta: '#bb9af7',
        brightCyan: '#7dcfff',
        brightWhite: '#c0caf5',
      },
      allowProposedApi: true,
    });

    const fitAddon = new FitAddon();
    term.loadAddon(fitAddon);
    term.loadAddon(new WebLinksAddon());
    term.open(termRef.current);
    fitAddon.fit();
    xtermRef.current = term;

    const statusEl = document.getElementById('conn-status');

    function connect() {
      term.writeln('\r\n\x1b[33mConnecting to server...\x1b[0m');
      if (statusEl) {
        statusEl.textContent = 'Connecting...';
        statusEl.className = 'status';
      }

      const ws = new WebSocket(WS_URL);

      ws.onopen = () => {
        term.writeln('\x1b[32mConnected!\x1b[0m\r\n');
        if (statusEl) {
          statusEl.textContent = 'Connected';
          statusEl.className = 'status connected';
        }
        // Send initial resize
        ws.send(JSON.stringify({ type: 'resize', cols: term.cols, rows: term.rows }));
      };

      ws.onmessage = (event) => {
        term.write(event.data);
      };

      ws.onclose = () => {
        term.writeln('\r\n\x1b[31mDisconnected. Reconnecting in 3s...\x1b[0m');
        if (statusEl) {
          statusEl.textContent = 'Disconnected';
          statusEl.className = 'status';
        }
        setTimeout(connect, 3000);
      };

      ws.onerror = () => {
        ws.close();
      };

      term.onData((data) => {
        if (ws.readyState === WebSocket.OPEN) {
          ws.send(data);
        }
      });

      term.onResize(({ cols, rows }) => {
        if (ws.readyState === WebSocket.OPEN) {
          ws.send(JSON.stringify({ type: 'resize', cols, rows }));
        }
      });

      // Store for cleanup
      term._ws = ws;
    }

    connect();

    const handleResize = () => fitAddon.fit();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      if (term._ws) term._ws.close();
      term.dispose();
      xtermRef.current = null;
    };
  }, []);

  return <div ref={termRef} style={{ height: '100%', width: '100%' }} />;
}
